export const MAX_RETAILER_WORKBOOK_BYTES = 25 * 1024 * 1024;

interface RetailerWorkbookFile {
  name: string;
  size: number;
}

export function validateRetailerWorkbook(
  file: RetailerWorkbookFile,
): string | null {
  if (!file.name.toLowerCase().endsWith(".xlsx")) {
    return "Select an .xlsx retailer details workbook";
  }
  if (file.size > MAX_RETAILER_WORKBOOK_BYTES) {
    return "The workbook must be 25 MiB or smaller";
  }
  if (file.size === 0) {
    return "The workbook is empty";
  }
  return null;
}
